// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatNodeStyle_controllers__zHs\\+i {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  /* height:30%; */
}
.ChatNodeStyle_historyQuestiion__tnsJ0 {
  padding: 10px 15px;
  background-color: rgb(71, 69, 69);
  color: white;
  border-radius: 20px;
  font-size: 17px;
}
.ChatNodeStyle_historyQuestiion__tnsJ0:hover {
  background-color: black;
}
.ChatNodeStyle_hardcode_text__y64OP {
  margin-bottom: 10px;
  padding: 10px;
  background-color: rgb(245, 245, 245);
  border: 1px solid rgba(0, 0, 0, 0.02);
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
  color: var(--dark-color);
}
.ChatNodeStyle_hist_quest_ans__qM0Iz {
  font-size: 22px;
}
.ChatNodeStyle_backButton__d7mEG {
  /* margin: 12px auto; */
  outline: none;
  border: 1px solid gray;
  padding: 8px 12px;
  border-radius: 20px;
  background: gray;
  color: black;
  font-size: 15px;
  background-color: transparent;
}
.ChatNodeStyle_history_content__BncT\\+ {
  width: 100%;
  height: 100%;
}
.ChatNodeStyle_history_pre__xtLbY {
  width: 100%;
  height: 70%;
  overflow-y: auto;
  padding: 16px;
}
.ChatNodeStyle_hist_controlles__hKVVY {
  width: 100%;
  height: 30%;
  border-top: 1px solid #ccc;
  padding: 16px;
}
.ChatNodeStyle_his_qst__R-bgH {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.ChatNodeStyle_his_qst__R-bgH p {
  background-color: #007bff;
  color: white;
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 75%;
  word-wrap: break-word;
}
.ChatNodeStyle_his_ans__ttpyg {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.ChatNodeStyle_his_ans__ttpyg p {
  background-color: #f1f1f1;
  color: black;
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 75%;
  word-wrap: break-word;
}
.ChatNodeStyle_his_qst_statment__sWQyE {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.ChatNodeStyle_ansBtnContainer__JakN7 {
  display: flex;
  gap: 8px; /* Adds spacing between Add Answer and Remove Answer */
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewCreateAppF/ChatNodeStyle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ,EAAE,sDAAsD;EAChE,mBAAmB;AACrB","sourcesContent":[".controllers {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  /* height:30%; */\n}\n.historyQuestiion {\n  padding: 10px 15px;\n  background-color: rgb(71, 69, 69);\n  color: white;\n  border-radius: 20px;\n  font-size: 17px;\n}\n.historyQuestiion:hover {\n  background-color: black;\n}\n.hardcode_text {\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: rgb(245, 245, 245);\n  border: 1px solid rgba(0, 0, 0, 0.02);\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 6px;\n  color: var(--dark-color);\n}\n.hist_quest_ans {\n  font-size: 22px;\n}\n.backButton {\n  /* margin: 12px auto; */\n  outline: none;\n  border: 1px solid gray;\n  padding: 8px 12px;\n  border-radius: 20px;\n  background: gray;\n  color: black;\n  font-size: 15px;\n  background-color: transparent;\n}\n.history_content {\n  width: 100%;\n  height: 100%;\n}\n.history_pre {\n  width: 100%;\n  height: 70%;\n  overflow-y: auto;\n  padding: 16px;\n}\n.hist_controlles {\n  width: 100%;\n  height: 30%;\n  border-top: 1px solid #ccc;\n  padding: 16px;\n}\n.his_qst {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n.his_qst p {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 12px;\n  max-width: 75%;\n  word-wrap: break-word;\n}\n.his_ans {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n.his_ans p {\n  background-color: #f1f1f1;\n  color: black;\n  padding: 8px 12px;\n  border-radius: 12px;\n  max-width: 75%;\n  word-wrap: break-word;\n}\n.his_qst_statment {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n}\n.ansBtnContainer {\n  display: flex;\n  gap: 8px; /* Adds spacing between Add Answer and Remove Answer */\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controllers": `ChatNodeStyle_controllers__zHs+i`,
	"historyQuestiion": `ChatNodeStyle_historyQuestiion__tnsJ0`,
	"hardcode_text": `ChatNodeStyle_hardcode_text__y64OP`,
	"hist_quest_ans": `ChatNodeStyle_hist_quest_ans__qM0Iz`,
	"backButton": `ChatNodeStyle_backButton__d7mEG`,
	"history_content": `ChatNodeStyle_history_content__BncT+`,
	"history_pre": `ChatNodeStyle_history_pre__xtLbY`,
	"hist_controlles": `ChatNodeStyle_hist_controlles__hKVVY`,
	"his_qst": `ChatNodeStyle_his_qst__R-bgH`,
	"his_ans": `ChatNodeStyle_his_ans__ttpyg`,
	"his_qst_statment": `ChatNodeStyle_his_qst_statment__sWQyE`,
	"ansBtnContainer": `ChatNodeStyle_ansBtnContainer__JakN7`
};
export default ___CSS_LOADER_EXPORT___;
